import React from "react";

const ModalFormInputRow = (props) => {
    return (
        <div className="form-row mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
                {props.title}
            </label>
            {props.children}
        </div>
    );
}

export default ModalFormInputRow;
